import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=7209522e&scoped=true"
import script from "./goodsDetails.vue?vue&type=script&lang=js"
export * from "./goodsDetails.vue?vue&type=script&lang=js"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=7209522e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7209522e",
  null
  
)

export default component.exports